import { Scene, SceneId } from "../gameData";
import { expectGameContext } from ".";

export function expectScene(sceneId: SceneId): Scene {
    const ctx = expectGameContext();
    const scene = ctx.gameData.scenes[sceneId];
    if (!scene) {
        throw new Error(`Expected Scene with ID "${sceneId}"`);
    }
    return scene;
}
